export const CONFLUENT_MISSING_PHONE_NOTE_ID = "missing_phone";
